import { v2Request } from "../helpers/request";

export const createAppointmentTemplate = (payload: JObj) => {
  return v2Request("/appointment-template", {
    body: JSON.stringify(payload),
    method: "POST",
  });
};
export const createAppointmentTemplateWithAppointments = (payload: JObj) => {
  return v2Request("/appointment-template/add-to-calendar", {
    body: JSON.stringify(payload),
    method: "POST",
  });
};
export const addTemplateAppointments = (payload: JObj) => {
  return v2Request("/appointment-template/add-appointments", {
    body: JSON.stringify(payload),
    method: "POST",
  });
};
export const removeTemplateAppointments = (payload: JObj) => {
  return v2Request("/appointment-template/remove-appointments", {
    body: JSON.stringify(payload),
    method: "DELETE",
  });
};
export const removeTemplate = (payload: JObj) => {
  return v2Request("/appointment-template/", {
    body: JSON.stringify(payload),
    method: "DELETE",
  });
};
export const updateTemplate = (payload: JObj) => {
  return v2Request("/appointment-template", {
    body: JSON.stringify(payload),
    method: "PUT",
  });
};
export const checkTemplateAvailability = (payload: JObj) => {
  return v2Request("/appointment-template/check", {
    body: JSON.stringify(payload),
    method: "POST",
  });
};
export const getAppointmentTemplates = () => {
  return v2Request(`/appointment-template`);
};
export const createOffDaysTemplate = (payload: JObj) => {
  return v2Request("/appointment-template/off/", {
    body: JSON.stringify(payload),
    method: "POST",
  });
};
export const checkOffDayAvailability = (payload: JObj) => {
  return v2Request("/appointment-template/off-check", {
    body: JSON.stringify(payload),
    method: "POST",
  });
};
export const getOffDayTemplates = () => {
  return v2Request(`/appointment-template/off`);
};
export const updateOffDayTemplate = (payload: JObj) => {
  return v2Request("/appointment-template/off", {
    body: JSON.stringify(payload),
    method: "PUT",
  });
};
export const removeOffDays = (payload: JObj) => {
  return v2Request("/appointment-template/off", {
    body: JSON.stringify(payload),
    method: "DELETE",
  });
};
export const getCalendarOffDays = (from: string, to: string) => {
  return v2Request(`/appointment-template/off/${from}/${to}`);
};
export const toggleOffDayTemplateCalendarVisibility = (payload: JObj) => {
  return v2Request("/appointment-template/off/calendar-toggle", {
    body: JSON.stringify(payload),
    method: "PUT",
  });
};
export const unlinkAppointmentFromTemplate = (payload: JObj) => {
  return v2Request("/appointment-template/unlink", {
    body: JSON.stringify(payload),
    method: "POST",
  });
};
